import React, { useState } from "react";

import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

import { faPlusCircle, faSyncAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Card from "../../UI/Card/Card";
import SandBoxApplicationsList from "./SandBoxApplicationsList";
import Button from "../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../UI/ErrorPanel/ErrorPanel";
import EmptyState from "../../UI/State/EmptyState";
import CornerBadge from "../../UI/Badge/CornerBadge";

import * as SandBoxApplicationsActions from "../../../middleware/Store/Actions/SandBoxApplicationsActions";
import * as PathUtils from "../../Utils/PathUtils";
import * as ApplicationConstant from "../../Constants/ApplicationConstant";
import * as ContactUtils from "../../Utils/ContactUtils";
import * as DeveloperUtils from "../../Utils/DeveloperUtils";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "SANDBOX_APPLICATIONS";

const SandBoxApplications = (props) => {
    const intl = useIntl();
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");

    const handleCreateApplication = () => {
        LogService.trace(LOG_TAG, "handleCreateApplication");
        const path = PathUtils.addOrUpdateQueryParameterToPathString(ApplicationConstant.APPLICATION_PATH + ApplicationConstant.CREATE_PATH, ApplicationConstant.ApplicationSandBoxTagName, true);
        history.push(path);
    }

    const handleOnApplicationsRefresh = () => {
        LogService.trace(LOG_TAG, "handleOnApplicationsRefresh");
        if (props.getSandBoxApplications) {
            props.getSandBoxApplications()
                .then(() => {
                    LogService.info(LOG_TAG, "handleOnApplicationsRefresh", "success");
                    setErrorMessage("");
                })
                .catch(() => {
                    LogService.error(LOG_TAG, "handleOnApplicationsRefresh", "error");
                    setErrorMessage(intl.messages.applicationsRetrieveErrorMessage);
                });
        }
    }

    LogService.trace(LOG_TAG, "render");

    let canShowApplications = ContactUtils.isDeveloper(props.sandBoxUser) || ContactUtils.isSuperAdminOrAppSuperAdmin(props.sandBoxUser);

    let display = null;
    if (canShowApplications) {
        let contentDisplay = null;
        if (props.progress) {
            contentDisplay = <EmptyState progress={true} text="" />;
        } else if (canShowApplications) {
            contentDisplay = [];
            contentDisplay.push(
                <SandBoxApplicationsList
                    key="1"
                    onApplicationsRefresh={handleOnApplicationsRefresh}
                />
            );
            contentDisplay.push(
                <Button
                    id="createApplicationButtonId"
                    key="2"
                    label={intl.messages.applicationCreateButton}
                    icon={faPlusCircle}
                    className="btn-submit mt-3"
                    onClick={handleCreateApplication}
                />
            );

            if (props.sandBoxApplications?.length === 0)
                contentDisplay.push(
                    <Button
                        key="3"
                        id="refreshApplicationButtonId"
                        label={intl.messages.refresh}
                        icon={faSyncAlt}
                        className="btn-submit mt-3 ml-2"
                        onClick={handleOnApplicationsRefresh}
                    />
                );

            if (errorMessage)
                contentDisplay.push(
                    <div key="4">
                        <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                    </div>
                );
        }

        display =
            <Card title={intl.messages.applicationsCardTitle} subtitle={intl.messages.sandboxCardSubTitle}>
                <CornerBadge label="SANDBOX" />
                {contentDisplay}
            </Card>
    } else if (props.sandBoxUser) {//=isSandboxAvailable
        const sandBoxUrl = DeveloperUtils.getWebClientSandBoxUrl(props.sandBoxBaseServerUrl)
        display =
            <Card header={false}>
                <div className="panel bg-fog">
                    {intl.messages.sandBoxApplicationsNotDeveloperMessage}
                    <br />
                    <FontAwesomeIcon icon={faArrowRight} className="mr-2 icon-green" />
                    <a href={sandBoxUrl.toString()} target="_blank" rel="noopener noreferrer"
                        className="text-green ml-2">{sandBoxUrl.hostname}</a>
                </div>
            </Card >;
    }

    return display;
}

const mapStateToProps = state => {
    return {
        sandBoxUser: state.sandBoxContacts.user,
        sandBoxContacts: state.sandBoxContacts.contacts,
        sandBoxApplications: state.sandBoxApplications.applications,
        progress: state.sandBoxApplications.progress,
        sandBoxBaseServerUrl: state.sandBoxAuthentication.account.baseServerUrl
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSandBoxApplications: (criteria) => dispatch(SandBoxApplicationsActions.getAllApplications(criteria)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SandBoxApplications);